module.exports = __webpack_public_path__ + "img/GR.8e096059.svg";